/* CAR'CONFORT – ajout au panier depuis les sections cc-* (produit seul ou kit). */
(function () {
  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
  }
  function cartUrl() {
    return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-cc-add]');
    if (!button) return;
    event.preventDefault();

    let items;
    try {
      items = JSON.parse(button.getAttribute('data-cc-add'));
    } catch (e) {
      return;
    }
    if (!items || !items.length) return;

    const label = button.querySelector('.cc-btn__label');
    const originalLabel = label ? label.textContent : '';
    const errorBox = button.closest('[data-cc-buy]') ? button.closest('[data-cc-buy]').querySelector('[data-cc-error]') : null;
    if (errorBox) errorBox.textContent = '';

    const drawer = document.querySelector('cart-drawer');
    const body = { items: items };
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(cartAddUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await response.json();

      if (!response.ok || data.status) {
        if (errorBox) errorBox.textContent = data.description || data.message || 'Ajout impossible pour le moment.';
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cc-add', cartData: data });
      }

      if (drawer && data.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
      } else {
        window.location.href = cartUrl();
        return;
      }

      button.classList.add('is-added');
      if (label) label.textContent = button.getAttribute('data-cc-added-label') || 'Ajouté';
      setTimeout(function () {
        button.classList.remove('is-added');
        if (label) label.textContent = originalLabel;
      }, 2500);
    } catch (e) {
      if (errorBox) errorBox.textContent = 'Connexion interrompue, réessayez.';
    } finally {
      button.removeAttribute('aria-busy');
    }
  });
})();
